<template>
  <!-- copilot begin -->
  <div class="policy-cost-view" v-loading="pageLoading || loading">
    <div class="cost-table-header" v-if="policyTabs.length > 0 && (showPolicyTabs || showTemplateActions)">
      <div v-if="showPolicyTabs" class="policy-tags">
        <span class="policy-label">已选政策：</span>
        <span v-for="policy in policyTabs" :key="policy.modelId" :class="['policy-tag', { 'is-active': activePolicyId === policy.modelId }]" @click="handlePolicyChange(policy.modelId)">
          {{ policy.modelName }}
        </span>
      </div>
      <div v-else class="policy-tags"></div>
      <div v-if="showTemplateActions" class="table-actions">
        <el-button type="primary" size="small" @click="getUseTemplate">使用模版</el-button>
        <el-button type="primary" size="small" @click="handleSaveAsTemplate">保存为模版</el-button>
      </div>
    </div>

    <div v-if="currentPolicy" class="cost-table-wrapper">
      <cost-table ref="costTable" :policy-data="currentPolicy" :is-cost-edit="isCostEdit" :precision="computedPrecision" :show-range="showRange" />
    </div>

    <el-dialog :visible.sync="saveSlotDialogVisible" title="保存为模板" width="40%" :close-on-click-modal="false" custom-class="template-dialog">
      <div class="save-slot-dialog">
        <p class="dialog-desc">保存当前成本表为模板: 可保存为新的模板或替代已有的模板。成本模板最多为五个。</p>
        <div class="slot-list">
          <el-radio-group v-model="radioValue" class="slot-radio-group">
            <div v-for="slot in nonEmptyTemplateSlots" :key="slot.id" class="list-item" :class="{ 'is-selected': radioValue === slot.id }" @click="handleSlotSelect(slot.id)">
              <div class="item-content">
                <div class="item-name">{{ slot.name || slot.templateName }}</div>
              </div>
              <el-radio :label="slot.id" class="slot-radio">&nbsp;</el-radio>
            </div>
          </el-radio-group>
          <div class="new-template-box" @click="handleSaveAsNewTemplate">
            <i class="el-icon-plus add-icon"></i>
            <span>保存为新的模板</span>
          </div>
        </div>
        <div class="dialog-footer">
          <el-button class="confirm-btn" @click="handleConfirmSlotSave">保存</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="saveNameDialogVisible" title="保存为新模板" width="420px" :close-on-click-modal="false" custom-class="template-dialog save-name-dialog">
      <el-form>
        <el-form-item>
          <el-input v-model="newTemplateName" maxlength="10" show-word-limit>
            <template slot="prefix">
              <span class="input-label-prefix">模板名称</span>
            </template>
          </el-input>
        </el-form-item>
      </el-form>

      <div class="dialog-footer">
        <el-button type="primary" @click="handleConfirmSaveTemplate" class="confirm-btn">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="loadTemplateDialogVisible" title="使用模板" width="40%" :close-on-click-modal="false" custom-class="template-dialog">
      <div class="get-template-dialog">
        <p class="dialog-desc">选择要载入的模板: 点击模板可直接载入，载入后将替换当前的费率配置。</p>

        <div class="template-list">
          <div v-for="template in currentPolicyTemplates" :key="template.id" class="list-item" @click="handleSelectLoadTemplate(template)">
            <div class="item-content">
              <div class="item-name">{{ template.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <div v-if="showButtons" class="button-area">
      <template v-if="isCostEditMode">
        <el-button type="primary">保存</el-button>
        <el-button>取消</el-button>
      </template>
    </div>

    <div v-if="showRemark" class="cost-instruction">
      <div class="instruction-title">说明：</div>
      <p>1、成本最多支持输入3位小数，超过3位小数则系统自动保留3位小数；</p>
    </div>
  </div>
  <!-- copilot end -->
</template>

<script>
// copilot begin
import CostTable from "./CostTable.vue";

export default {
  name: "PolicyCostView",
  components: { CostTable },
  props: {
    // 政策成本数据
    policiesData: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    // 0-只读，1-可编辑
    isCostEdit: {
      type: Number,
      default: 0,
    },
    // 成本表类型：0-商户，1-代理商
    costTableType: {
      type: [String, Number],
      default: "0",
    },
    // 费率精度
    precision: {
      type: Number,
      default: 3,
    },
    // 是否显示取消/保存操作按钮
    showButtons: {
      type: Boolean,
      default: false,
    },
    // 是否显示说明文字
    showRemark: {
      type: Boolean,
      default: false,
    },
    // 是否显示模板操作按钮（使用模板、保存模板）
    showTemplateActions: {
      type: Boolean,
      default: true,
    },
    // 是否显示政策标签页
    showPolicyTabs: {
      type: Boolean,
      default: true,
    },
    // 是否显示费率范围
    showRange: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activePolicyId: "",
      pageLoading: false,
      saveSlotDialogVisible: false,
      saveNameDialogVisible: false,
      loadTemplateDialogVisible: false,
      templateSlots: [
        {
          id: 1, templateName: "", policyId: "", isEmpty: true,
        },
        {
          id: 2, templateName: "", policyId: "", isEmpty: true,
        },
        {
          id: 3, templateName: "", policyId: "", isEmpty: true,
        },
        {
          id: 4, templateName: "", policyId: "", isEmpty: true,
        },
        {
          id: 5, templateName: "", policyId: "", isEmpty: true,
        },
      ],
      selectedSlot: null,
      radioValue: null,
      newTemplateName: "",
      currentPolicyTemplates: [],
    };
  },
  computed: {
    isCostEditMode() {
      return this.isCostEdit === 1;
    },
    policyTabs() {
      return this.policiesData;
    },
    currentPolicy() {
      if (!this.activePolicyId) return null;
      return this.policiesData.find(item => item.modelId === this.activePolicyId);
    },
    computedPrecision() {
      if (this.precision !== 3) {
        return this.precision;
      }

      if (String(this.costTableType) === "0") {
        return 2;
      }

      return 3;
    },
    nonEmptyTemplateSlots() {
      return this.templateSlots.filter(s => !s.isEmpty);
    },
  },
  watch: {
    policiesData: {
      handler(newData) {
        if (newData && newData.length > 0 && !this.activePolicyId) {
          this.activePolicyId = newData[0].modelId;
        }
      },
      immediate: true,
    },
  },
  methods: {
    handlePolicyChange(policyId) {
      this.activePolicyId = policyId;
      this.$emit("policy-change", policyId);
    },
    handleSaveAsTemplate() {
      this.getTemplateSlots();
      this.saveSlotDialogVisible = true;
    },
    getUseTemplate() {
      const policyNo = this.currentPolicy && this.currentPolicy.policyId;
      if (!policyNo) {
        this.$message.warning("请先选择政策");
        return;
      }
      const sessionId = localStorage.getItem("sessionId");
      const self = this;
      this.$$api_costTemplate_queryCostPolicyCostTemplate(
        {
          templateType: 2,
          policyNo,
          sessionId,
        },
        (res) => {
          if (String(res.error_code) !== "0") {
            self.$message.error(res.error_msg || "查询模板列表失败");
            return;
          }
          self.currentPolicyTemplates = res.data || [];
          self.loadTemplateDialogVisible = true;
        },
      );
    },
    getTemplateSlots() {
      const policyNo = this.currentPolicy && this.currentPolicy.policyId;
      if (!policyNo) {
        return;
      }

      const self = this;
      this.$$api_costTemplate_queryCostPolicyCostTemplate(
        {
          templateType: 2,
          policyNo,
          sessionId: localStorage.getItem("sessionId"),
        },
        (res) => {
          if (String(res.error_code) !== "0") {
            self.$message.error(res.error_msg || "加载模板槽位失败");
            return;
          }
          const slots = [];
          const templates = res.data || [];

          // 已有模板
          templates.slice(0, 5).forEach((template) => {
            slots.push({
              id: template.id,
              templateName: template.name,
              policyId: policyNo,
              isEmpty: false,
            });
          });

          // 补充空槽位
          const emptySlotCount = Math.max(0, 5 - templates.length);
          for (let i = 0; i < emptySlotCount; i++) {
            slots.push({
              id: templates.length + i + 1,
              templateName: "",
              policyId: "",
              isEmpty: true,
            });
          }

          self.templateSlots = slots;
        },
      );
    },
    handleSlotSelect(slotId) {
      this.radioValue = slotId;
      this.selectedSlot = this.templateSlots.find(s => s.id === slotId) || null;
    },
    handleConfirmSlotSave() {
      if (!this.selectedSlot) {
        this.$message.warning("请选择一个栏位");
        return;
      }

      if (this.selectedSlot.isEmpty) {
        this.saveSlotDialogVisible = false;
        this.saveNameDialogVisible = true;
        this.newTemplateName = "";
      } else {
        const slotName = this.selectedSlot.name || this.selectedSlot.templateName;
        const self = this;
        this.$confirm(`确定要覆盖模板"${slotName}"吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            self.saveTemplate(self.selectedSlot.id, slotName);
          })
          .catch(() => {});
      }
    },
    handleSaveAsNewTemplate() {
      const emptySlot = this.templateSlots.find(slot => slot.isEmpty);
      if (!emptySlot) {
        this.$message.warning("模板槽位已满，请选择一个已有槽位进行覆盖");
        return;
      }
      this.selectedSlot = emptySlot;
      this.saveNameDialogVisible = true;
      this.newTemplateName = "";
    },
    handleConfirmSaveTemplate() {
      if (!this.newTemplateName || this.newTemplateName.trim() === "") {
        this.$message.error("请输入模板名称");
        return;
      }

      if (this.newTemplateName.length > 10) {
        this.$message.error("模板名称不能超过10个字符");
        return;
      }

      this.saveTemplate(this.selectedSlot.id, this.newTemplateName);
    },
    saveTemplate(slotId, templateName) {
      const policy = this.currentPolicy;
      if (!policy) {
        this.$message.error("请先选择政策");
        return;
      }

      // 构建模板详情数据以供上传
      const buildTemplateDetails = list => (list || []).map((item) => {
        const result = {
          feeType: item.feeType,
        };
        if (item.currentValue && item.currentValue.t0FeeDetail) {
          result.t0FeeDetail = Object.assign({}, item.currentValue.t0FeeDetail);
        }
        if (item.currentValue && item.currentValue.t1FeeDetail) {
          result.t1FeeDetail = Object.assign({}, item.currentValue.t1FeeDetail);
        }

        return result;
      });

      const params = {
        templateType: 2,
        policyNo: policy.policyId,
        templateName,
        templateDetails: {
          domesticTransAgentCostDetailList: buildTemplateDetails(policy.domesticTransAgentCostDetailList),
          foreignCardTransAgentCostDetailList: buildTemplateDetails(policy.foreignCardTransAgentCostDetailList),
        },
        sessionId: localStorage.getItem("sessionId"),
        remark: "",
      };

      if (this.selectedSlot && !this.selectedSlot.isEmpty) {
        params.templateId = this.selectedSlot.id;
      }

      const self = this;
      this.$$api_costTemplate_updateCostPolicyCostTemplate(params, (res) => {
        if (String(res.error_code) !== "0") {
          self.$message.error(res.error_msg || "保存模板失败");
          return;
        }

        self.$message.success("模板保存成功");
        self.saveNameDialogVisible = false;
        self.saveSlotDialogVisible = false;
        self.getTemplateSlots();
      });
    },
    // 选择要载入的模板（二次确认后载入）
    handleSelectLoadTemplate(template) {
      const self = this;
      this.$confirm("载入模板时，模板费率将覆盖你刚填写的成本表费率，确定要载入该模板么？", "确认载入", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          self.getTemplateData(template);
        })
        .catch(() => {});
    },
    // 载入模板数据
    getTemplateData(template) {
      const policyNo = this.currentPolicy && this.currentPolicy.policyId;
      if (!policyNo) {
        this.$message.error("请先选择政策");
        return;
      }

      this.pageLoading = true;

      const self = this;
      this.$$api_costTemplate_queryCostPolicyCostTemplateDetail(
        {
          templateType: 2,
          templateId: template.id,
          policyNo,
          sessionId: localStorage.getItem("sessionId"),
        },
        (res) => {
          self.pageLoading = false;

          if (String(res.error_code) !== "0") {
            self.$message.error(res.error_msg || "获取模板详情失败");
            return;
          }

          const data = res.data;
          if (!data) {
            self.$message.error("获取模板详情失败");
            return;
          }

          if (self.currentPolicy) {
            // 处理国内交易费率
            if (data.domesticTransAgentCostDetailList) {
              data.domesticTransAgentCostDetailList.forEach((item) => {
                const currentItem = (self.currentPolicy.domesticTransAgentCostDetailList || []).find(i => i.feeType === item.feeType);
                if (currentItem && item.currentValue) {
                  currentItem.currentValue = currentItem.currentValue || {};
                  currentItem.currentValue.t0FeeDetail = Object.assign({}, item.currentValue.t0FeeDetail);
                  currentItem.currentValue.t1FeeDetail = Object.assign({}, item.currentValue.t1FeeDetail);
                }
              });
            }

            // 处理外卡交易费率
            if (data.foreignCardTransAgentCostDetailList) {
              data.foreignCardTransAgentCostDetailList.forEach((item) => {
                const currentItem = (self.currentPolicy.foreignCardTransAgentCostDetailList || []).find(i => i.feeType === item.feeType);
                if (currentItem && item.currentValue) {
                  currentItem.currentValue = currentItem.currentValue || {};
                  currentItem.currentValue.t0FeeDetail = Object.assign({}, item.currentValue.t0FeeDetail);
                  currentItem.currentValue.t1FeeDetail = Object.assign({}, item.currentValue.t1FeeDetail);
                }
              });
            }
          }

          self.$message.success("模板载入成功");
          self.loadTemplateDialogVisible = false;
        },
      );
    },
    validate() {
      return (this.$refs.costTable && this.$refs.costTable.validateAll()) || [];
    },
    getModifiedData() {
      if (!this.currentPolicy) return null;
      const currentValues = (list) => {
        if (!list || !Array.isArray(list)) return [];
        return list.map((item) => {
          const result = {
            feeType: item.feeType,
          };

          if (item.currentValue && item.currentValue.t0FeeDetail) {
            result.t0FeeDetail = { ...item.currentValue.t0FeeDetail };
          }

          if (item.currentValue && item.currentValue.t1FeeDetail) {
            result.t1FeeDetail = { ...item.currentValue.t1FeeDetail };
          }

          return result;
        });
      };

      return {
        policyNo: this.currentPolicy.policyNo,
        domesticTransAgentCostDetailList: currentValues(this.currentPolicy.domesticTransAgentCostDetailList),
        foreignCardTransAgentCostDetailList: currentValues(this.currentPolicy.foreignCardTransAgentCostDetailList),
      };
    },
  },
};
// copilot end
</script>

<style scoped lang="scss">
// copilot start
.policy-cost-view {
  .cost-table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
    gap: 12px;

    .policy-tags {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
      flex: 1;

      .policy-label {
        color: #909399;
        white-space: nowrap;
        margin-right: 4px;
      }

      .policy-tag {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        padding: 4px 10px;
        font-size: 13px;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        background-color: #fff;
        color: #606266;
        cursor: pointer;
        transition: all 0.2s;
        user-select: none;

        &:hover {
          border-color: #008cff;
          color: #008cff;
        }

        &.is-active {
          background-color: #008cff;
          border-color: #008cff;
          color: #fff;
        }
      }
    }

    .table-actions {
      display: flex;
      align-items: center;
      gap: 8px;
      flex-shrink: 0;
    }
  }

  .cost-table-wrapper {
    margin-bottom: 16px;
  }

  .button-area {
    margin-top: 16px;
    text-align: right;
  }

  .cost-instruction {
    margin-top: 20px;
    padding: 12px;
    background-color: #f5f7fa;
    border-radius: 4px;

    .instruction-title {
      margin-bottom: 8px;
      font-weight: bold;
      color: #e6a23c;
    }

    p {
      margin: 4px 0;
      color: #606266;
    }
  }
}

/deep/ .template-dialog {
  .el-dialog {
    border-radius: 15px;
    overflow: hidden;
  }

  .el-dialog__header {
    padding: 0;
    margin: 0;
    border-bottom: none;

    .el-dialog__title {
      font-weight: 500;
      font-size: 16px;
      color: #000033;
      line-height: 70px;
      padding-left: 25px;
    }

    .el-dialog__headerbtn {
      top: 12px;
      right: 12px;
      width: 24px;
      height: 24px;
    }
  }

  .el-dialog__body {
    padding: 0 25px 25px;

    .dialog-footer {
      margin-top: 20px;
      text-align: center;

      .confirm-btn {
        width: 120px;
        height: 36px;
        font-size: 14px;
        font-weight: 400;
        color: #ffffff;
        background: linear-gradient(90deg, #1f9eff, #027aff);
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: all 0.2s;
      }
    }
  }

  .input-label-prefix {
    color: #000 !important;
    font-weight: 400;
    font-size: 12px;
    margin-right: 8px;
  }
}

.save-slot-dialog,
.get-template-dialog {
  .dialog-desc {
    margin-bottom: 16px;
    font-size: 14px;
    font-weight: 400;
    color: #8694a2;
    line-height: 33px;
  }

  .list-item {
    display: flex;
    align-items: center;
    width: 100%;
    height: 50px;
    padding: 0 12px;
    margin-bottom: 12px;
    background-color: #ffffff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    cursor: pointer;
    transition: border-color 0.2s;
    box-sizing: border-box;

    &:hover,
    &.is-selected {
      border-color: #c0c4cc;
    }

    .item-content {
      flex: 1;
      overflow: hidden;

      .item-name {
        font-weight: 500;
        font-size: 12px;
        color: #141938;
        line-height: 50px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

.save-slot-dialog {
  .slot-list {
    /deep/ .slot-radio-group {
      width: 100%;
      display: block;
    }

    /deep/ .slot-radio {
      margin-left: 12px;
      flex-shrink: 0;

      .el-radio__label {
        display: none;
      }

      .el-radio__inner {
        width: 20px !important;
        height: 20px !important;
      }

      .el-radio__input.is-checked .el-radio__inner {
        background-color: #52c41a !important;
        border-color: #52c41a !important;

        &::after {
          width: 5px !important;
          height: 9px !important;
          border-radius: 0 !important;
          background-color: transparent !important;
          border-right: 2px solid #fff !important;
          border-bottom: 2px solid #fff !important;
          transform: rotate(45deg) !important;
          top: 2px !important;
          left: 6px !important;
        }
      }
    }

    .new-template-box {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 50px;
      margin-top: 8px;
      font-size: 12px;
      color: #008cff;
      border: 1px dashed #008cff;
      border-radius: 4px;
      cursor: pointer;
      transition: background-color 0.2s;
      box-sizing: border-box;

      .add-icon {
        margin-right: 8px;
        font-size: 16px;
      }

      &:hover {
        background-color: rgba(0, 140, 255, 0.05);
      }
    }
  }
}

/deep/ .save-name-dialog {
  z-index: 3001 !important;
}
// copilot end
</style>
